import useSWR from "swr";
import axios from "axios";

function usePartnerCompanies({ page, perPage, sortField, sortOrder }) {
  return useSWR([`${process.env.REACT_APP_API_URL}/partner-companies`, page, perPage, sortField, sortOrder],
    async ([url, page, perPage, sortField, sortOrder]) => {
      const params = new URLSearchParams();

      if (page) params.append('page', page);
      if (perPage) params.append('perPage', perPage);
      if (sortField) params.append('sortField', sortField);
      if (sortOrder) params.append('sortOrder', sortOrder);

      const { data: { partnerCompanies, count } } = await axios.get(`${url}?${params.toString()}`);

      return { partnerCompanies, count };
    });
}

export default usePartnerCompanies;
